import React, { Component } from "react";
import { Table, Grid, Row, Col, Modal, ButtonToolbar, Button } from 'react-bootstrap';
import { PropTypes } from 'prop-types';

import { UploadFileForm } from './forms/UploadFileForm';
import { PaginationBuilder } from '../../PaginationBuilder';
import { PaginationHelper } from '../../helpers/PaginationHelper';
import { SearchHelper } from '../../helpers/SearchHelper';
import { SettingsCommand } from '../commands/SettingsCommand';
import { UploadsCommand } from "../commands/UploadsCommand";
import { LoadingSpinner } from '../../LoadingSpinner';
import { HandleMessage } from '../../HandleMessage';
import { TitleRow } from '../../TitleRow';
import { SearchBar } from '../../SearchBar';
import { TableButton } from '../../TableButton';

export class SettingsSpiderMaps extends Component {
    static contextTypes = {
        selectApp: PropTypes.func
    }

    constructor(props) {
        super(props);

        this.state = {
            table: {
                data: [],
                page: 1,
                elementsPerPage: 10,
                filter: ""
            },
            form: {
                data: undefined
            },
            stopImageLink: undefined,
            actions: {
                isLoading: true,
                isUpdating: false
            },
            commands: {
                settingsCommand: new SettingsCommand(),
                uploadsCommand: new UploadsCommand()
            },
            message: {
                show: false,
                message: undefined,
                style: undefined,
                icon: undefined,
                title: ""
            }
        };
    }

    componentDidMount() {
        this.context.selectApp('spidermap', false);
        this.getStopsList();
    }

    // -----------------------

    getStopsList(resetData = false) {
        if (resetData) {
            const { actions, table } = this.state;

            table.data = [];
            actions.isLoading = true;

            this.setState({
                table: table,
                actions: actions
            });
        }

        const { commands } = this.state;

        commands.settingsCommand.listStops(
            (a) => this.successCallback(a),
            (a) => this.errorCallback(a, true)
        );
    }

    // -----------------------

    successCallback(result) {
        const { table, actions } = this.state;

        const totalPages = PaginationHelper.getTotalPages(result.length, table.elementsPerPage);

        actions.isLoading = false;
        table.data = result;
        if (0 !== totalPages) {
            table.page = table.page > totalPages ? totalPages : table.page;
        }
        else {
            table.page = 1;
        }

        // Update table
        this.setState({
            table: table,
            actions: actions
        });
    }

    errorCallback(message, reset = false) {
        const { table, actions } = this.state;

        actions.isLoading = false;
        if (reset) {
            table.page = 1;
            table.data = [];
        }

        this.setState({
            table: table,
            actions: actions,
            message: {
                show: true,
                message: message,
                style: "danger",
                title: "Erro",
                icon: "remove"
            }
        });
    }

    stopImageSuccessCallback(link) {
        this.setState({
            stopImageLink: link
        });
    }

    operationSuccessCallback(messageReceived, updateAction) {
        const { actions, message } = this.state;

        actions[updateAction] = false;

        if (message.show) {
            messageReceived = `${message.message}\n${messageReceived}`;
        }

        this.setState({
            actions: actions,
            message: {
                show: true,
                message: messageReceived,
                style: "success",
                title: "Sucesso",
                icon: "ok"
            }
        });

        this.getStopsList(true);
    }

    operationErrorCallback(messageReceived, updateAction) {
        const { actions, message } = this.state;

        actions[updateAction] = false;

        if (message.show) {
            messageReceived = `${message.message}\n${messageReceived}`;
        }

        this.setState({
            actions: actions,
            message: {
                show: true,
                message: messageReceived,
                style: "danger",
                title: "Erro",
                icon: "remove"
            }
        });
    }

    // -----------------------

    onExitMessage() {
        this.setState({
            message: {
                show: false,
                message: undefined,
                style: undefined,
                icon: undefined,
                title: ""
            }
        });
    }

    onChangePage(pageNumber) {
        const { table } = this.state;
        table.page = pageNumber;

        this.setState({
            table: table
        });
    }

    onChangeElementsPerPage(elementsPerPage) {
        const { table } = this.state;
        const totalPages = PaginationHelper.getTotalPages(table.data.length, elementsPerPage);

        table.elementsPerPage = elementsPerPage;
        if (0 !== totalPages) {
            table.page = table.page > totalPages ? totalPages : table.page;
        }
        else {
            table.page = 1;
        }

        this.setState({
            table: table
        });
    }

    onSearch(filter) {
        const { table } = this.state;

        table.filter = filter;

        this.setState({
            table: table
        });
    }

    // -----------------------

    handleUploadImageClick(data) {
        const { form } = this.state;

        form.data = data;
        form.file = undefined;

        this.setState({
            form: form
        });
    }

    handleSeeImageClick(data) {
        const { commands } = this.state;

        commands.settingsCommand.getStopImageLink(
            data.code,
            (a) => this.stopImageSuccessCallback(a),
            (a) => this.errorCallback(a)
        );
    }

    handleStopImageViewExit() {
        this.setState({
            stopImageLink: undefined
        });
    }

    handleUploadStopImageFormExit() {
        const { form } = this.state;

        form.data = undefined;

        this.setState({
            form: form
        });
    }

    handleUploadStopImageSave(file) {
        const { form, commands, actions } = this.state;

        commands.uploadsCommand.uploadStopImage(
            form.data,
            file,
            (a) => this.operationSuccessCallback(a, "isUpdating"),
            (a) => this.operationErrorCallback(a, "isUpdating")
        );

        actions.isUpdating = true;
        this.setState({
            actions: actions
        });

        this.handleUploadStopImageFormExit();
    }

    // -----------------------

    renderUploadLink(data) {
        return (
            <TableButton
                icon="icon-edit"
                onClick={() => this.handleUploadImageClick(data)}
                title="Carregar"
            />
        );
    }

    renderSeeImageLink(data) {
        if(!data.isConfigured) {
            return null;
        }

        return (
            <TableButton
                marginRight
                icon="icon-map"
                onClick={() => this.handleSeeImageClick(data)}
                title="Ver Imagem"
            />
        );
    }

    renderButtons(data) {
        if (0 === data.type) {
            return null;
        }

        return (
            <ButtonToolbar className="pull-right">
                {this.renderSeeImageLink(data)}
                {this.renderUploadLink(data)}
            </ButtonToolbar>
        );
    }

    renderTable() {
        const { actions } = this.state;

        if (actions.isLoading || actions.isUpdating) {
            return (
                <LoadingSpinner />
            );
        }

        const { table } = this.state;

        const dataFiltered = SearchHelper.search({
            filter: table.filter,
            data: table.data,
            fields: ["code", "name"]
        });
        const totalPages = PaginationHelper.getTotalPages(dataFiltered.length, table.elementsPerPage);
        const activePage = totalPages < table.page ? totalPages : table.page;
        const partialData = dataFiltered.slice((activePage - 1) * table.elementsPerPage, activePage * table.elementsPerPage);

        return (
            <Grid className="margin-top-15" fluid>
                <Row>
                    <Col sm={12}>
                        <Table responsive striped hover className="margin-top-10">
                            <thead>
                                <tr>
                                    <th>Código</th>
                                    <th>Nome</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {partialData.map((data, idx) => <tr key={`layout-${idx}`}>
                                    <td>{data.code}</td>
                                    <td>{data.name}</td>
                                    <td>{this.renderButtons(data)}</td>
                                </tr>
                                )}
                            </tbody>
                        </Table>

                        <PaginationBuilder
                            currentPage={table.page}
                            elementsPerPage={table.elementsPerPage}
                            dataLength={dataFiltered.length}
                            onChangePage={(a) => this.onChangePage(a)}
                            onChangeElementsPerPage={(a) => this.onChangeElementsPerPage(a)} />
                    </Col>
                </Row>
            </Grid>
        );
    }

    renderForm() {
        const { form } = this.state;

        if (null === form.data || undefined === form.data) {
            return null;
        }

        return (
            <UploadFileForm data={form.data}
                onSave={(a) => this.handleUploadStopImageSave(a)}
                onHide={() => this.handleUploadStopImageFormExit()} />
        );
    }

    renderStopImageView() {
        const { stopImageLink } = this.state;

        if(undefined === stopImageLink || null == stopImageLink || "" === stopImageLink) {
            return null;
        }

        return (
            <Modal show={true}>
                <Modal.Header>
                    <Modal.Title>Ver Imagem</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <img alt="Imagem da paragem" className="width-100p" src={stopImageLink} />
                    <ButtonToolbar className="margin-top-10">
                        <Button onClick={() => this.handleStopImageViewExit()}> FECHAR </Button>
                    </ButtonToolbar>
                </Modal.Body>
            </Modal>
        );
    }

    render() {
        const { message } = this.state;

        return (
            <div>
                <TitleRow title="Spider Maps" showSeparator={true}>
                    <Col className="padding-0" xs={12} sm={12} md={8} mdOffset={4}>
                        <div className="search-bar">
                            <SearchBar onSearch={(a) => this.onSearch(a)} />
                        </div>
                    </Col>
                </TitleRow>

                {this.renderTable()}
                {this.renderForm()}
                {this.renderStopImageView()}

                <HandleMessage
                    title={message.title}
                    message={message.message}
                    style={message.style}
                    icon={message.icon}
                    show={message.show}
                    onHide={() => this.onExitMessage()} />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/spidermap/settings/SettingsSpiderMaps.js